import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase/config';
import './Auth.css';

const ForgotPassword = ({ switchToLogin }) => {
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [resetError, setResetError] = useState('');

  const validateEmail = (email) => {
    if (!email) {
      return 'Veuillez entrer votre adresse email';
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Veuillez entrer une adresse email valide';
    }
    
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation du formulaire
    const emailError = validateEmail(email);
    if (emailError) {
      setErrors({ email: emailError });
      return;
    }
    
    setLoading(true);
    setResetError('');
    setErrors({});
    
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
    } catch (error) {
      console.error('Erreur lors de la réinitialisation:', error);
      
      // Messages d'erreur conviviaux selon le type d'erreur Firebase
      if (error.code === 'auth/user-not-found') {
        setResetError('Aucun compte associé à cet email');
      } else if (error.code === 'auth/invalid-email') {
        setResetError('Adresse email invalide');
      } else if (error.code === 'auth/too-many-requests') {
        setResetError('Trop de tentatives. Veuillez réessayer plus tard.');
      } else {
        setResetError('Une erreur est survenue. Veuillez réessayer.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h3>Mot de passe oublié</h3>
      
      {resetError && <div className="error-message global-error">{resetError}</div>}
      
      {resetSent ? (
        <div className="reset-success">
          <p>Un email de réinitialisation a été envoyé à <strong>{email}</strong>.</p>
          <p>Veuillez vérifier votre boîte de réception et suivre les instructions.</p>
          <button 
            type="button" 
            className="btn btn-primary btn-block" 
            onClick={switchToLogin}
          >
            Retour à la connexion
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className={`form-group ${errors.email ? 'has-error' : ''}`}>
            <label htmlFor="reset-email">Email</label>
            <input
              type="email"
              id="reset-email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Entrez votre adresse email"
            />
            {errors.email && <div className="error-message">{errors.email}</div>}
          </div>
          
          <p className="reset-instructions">
            Nous vous enverrons un email contenant un lien pour réinitialiser votre mot de passe.
          </p>
          
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Envoi en cours...' : 'Réinitialiser mon mot de passe'}
          </button>
        </form>
      )}
      
      <div className="auth-switch">
        <button type="button" className="btn-link" onClick={switchToLogin}>
          Retour à la connexion
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;